module.exports = __webpack_public_path__ + "static/media/Girl-in-blazer-and-glasses-355934.18a076cf.jpg";